export default {
  syncBoxes: {
    title: "Synchroniseer folders",
    advice: "Ons advies is om in ieder geval de Inbox en Verzonden items te synchroniseren",
    toggleAll: "Zet alle folders aan/uit",
  },

  list: {
    noAccount: "U heeft nog geen synchronisatie account aangemaakt."
  },

  accountTypes: {
    outlook: "Outlook",
    custom: "Anders",
  },

  create: {
    title: "Nieuw imap account aanmaken",
    type: {
      label: "Account type",
      placeholder: "Selecteer een account type",
    },
    email: "E-mailadres",
    password: "Wachtwoord",
    host: {
      label: "Imap adres",
      placeholder: "b.v. imap.uw-domein.nl",
    },
    port: {
      label: "Poort",
      placeholder: '993',
    },
  },

  button: {
    save: "Imap account aanmaken",
    edit: "Opslaan",
    cancel: "Annuleren",
  },

  edit: {
    title: "Imap account bewerken"
  },

  api: {
    accountType: {
      notNull: "Selecteer een account type",
    },
    username: {
      notNull: "Voer een e-mailadres in"
    },
    password: {
      notNull: "Voer het wachtwoord in"
    },
    host: {
      notNull: "Voer een imap adres in",
    },
    port: {
      notNull: "Voer de poort in",
    },
    error: {
      found: "E-mail account bestaat al"
    },
  },

  help: {
    title: "E-mail synchronisatie",
    intro: "Door uw e-mailadres(sen) te synchroniseren met Stickyweb kunnen relevante e-mails automatisch aan de verschillende dossiers gekoppeld worden. Dit gebeurd op basis van de e-mailadressen die u aan bedrijven en contacten toewijst. Zo heeft u automatisch een goed en doorzoekbaar overzicht van uw e-mail contactmomenten.",
    folders: {
      title: "Folders",
      text: "Wanneer u het e-mail account aanmaakt, worden de folders van uw account opgehaald. U kunt dan zelf kiezen welke folders u wilt synchroniseren. Wij randen u aan om in ieder geval de Inbox en Verzonden items folders te synchroniseren, maar u kunt er natuurlijk ook voor een specifieke folder kiezen, zo heeft u zelf de controle in handen."
    }
  },
}
